var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Page",
    [
      _c(
        "template",
        { slot: "header-left-dropdown" },
        [
          _c("PageTabButtons", {
            attrs: {
              selectedList: _vm.requestHeaderLinks,
              translationGroup: "Request",
            },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "header-left-search" },
        [
          !_vm.showSelectedTransferList
            ? _c("Search", {
                staticClass: "search-box",
                attrs: {
                  componentName: "requestsTransfer",
                  suggestionValue: "name",
                  isSuggestionLoading: _vm.isSuggestionLoading,
                  suggestions: _vm.selectedStockItem,
                  customSuggestionPlaceHolder: _vm.$t(
                    "DirectOrders.searchPlaceholder"
                  ),
                  customSuggestionTitle: _vm.$t(
                    "DirectOrders.orders_search_SuggestionTitle"
                  ),
                },
                on: {
                  onChangeSearchValue: _vm.onChangeSearch,
                  onChangeQueryItem: _vm.setStockItem,
                  clearSearch: _vm.clearSearch,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "header-right-dropdown" },
        [
          !_vm.showSelectedTransferList
            ? _c("CustomDatepicker", {
                staticClass: "m-right-15",
                attrs: {
                  range: false,
                  useFilterReset: true,
                  pickerType: "manuel",
                },
                on: { resetDateFilter: _vm.resetDateFilter },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "header-right-content" },
        [
          !_vm.showSelectedTransferList
            ? _c(
                "Button",
                {
                  attrs: {
                    disabled: _vm.canOnlyTransferWithRequest,
                    primary: "",
                    size: "medium",
                    id: "btn-add-new-transfer-request-detail",
                    success: "",
                  },
                  on: { click: _vm.addNewDetail },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("Global.addDetail")))])]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("template", { slot: "toolbar-left" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showSelectedTransferList,
                expression: "!showSelectedTransferList",
              },
            ],
            staticClass: "filters",
          },
          [
            _c("storeFilter", {
              ref: "requestedTransferFromStoreList",
              attrs: {
                label: _vm.$t("RequestedTransfer.tableFieldSenderStore"),
                ignorePermission: true,
                permissionKey: "useStoreAndTransferStorePermission",
              },
              on: { submitFilter: _vm.getListWithFromStoreFilter },
            }),
            _c("BusinessMultiselect", {
              ref: "requestedTransferStoreListFilter",
              attrs: {
                componentName: "requested-transfer-to-store-filter",
                multiselectItems: _vm.toStoreList,
                label: _vm.$t("RequestedTransfer.tableFieldStore"),
                popupHeader: _vm.$t("Global.toolbar_Stores_PopupHeader"),
              },
              on: { submitFilter: _vm.getListWithStoreFilter },
            }),
            _c("itemGroupList", {
              ref: "requestedTransferItemGroup",
              attrs: { groupType: "itemGroup" },
              on: { submitFilter: _vm.getListWithGroupFilter },
            }),
            _c(
              "Button",
              {
                staticClass: "clear-filter-button border-gray-1 p-0 width-auto",
                on: { click: _vm.clearFilter },
              },
              [
                _c("Icon", {
                  staticClass: "icon-clear-filter",
                  attrs: { name: "icon-clear-filter" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "template",
        { slot: "toolbar-right" },
        [
          _vm.SelectedTransfers.length
            ? _c(
                "Button",
                {
                  staticClass: "selected-transfers m-right-10",
                  attrs: {
                    secondary: "",
                    size: "small",
                    iconName: !_vm.showSelectedTransferList
                      ? "icon-package"
                      : "icon-navigation-transfer",
                    iconClass: !_vm.showSelectedTransferList
                      ? "icon-package"
                      : "icon-navigation-transfer",
                  },
                  on: { click: _vm.openSelectedTransfers },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        !_vm.showSelectedTransferList
                          ? "Seçilenler (" + _vm.SelectedTransfers.length + ")"
                          : "Transfer Taleplerine Geri Dön"
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hideReasonPopup,
                  expression: "hideReasonPopup",
                },
              ],
              staticClass: "popup-container",
            },
            [
              !_vm.showSelectedTransferList
                ? _c(
                    "Button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isEmptyTransferList,
                          expression: "!isEmptyTransferList",
                        },
                      ],
                      attrs: {
                        secondary: "",
                        size: "small",
                        variant: "full",
                        id: "btn-requests-passive-transfer",
                        disabled: _vm.selectedItems.length === 0,
                      },
                      on: { click: _vm.showPassiveReasonForm },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Orders.makePassive")))])]
                  )
                : _vm._e(),
              _vm.showReasonButtonPopup
                ? _c(
                    "form",
                    {
                      staticClass: "order-passive-description-right-MiniPopup",
                      attrs: { id: "order-description-reason-form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.makeTransfersPassive.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "order-description-MiniPopup-label required",
                          attrs: { id: "order-description-reason-label" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Orders.Reason_Description_Input_Label")
                            )
                          ),
                        ]
                      ),
                      _c("customTextareaInput", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 128 },
                            expression: "{required: true, max: 128}",
                          },
                        ],
                        attrs: {
                          id: "transfer-description-reason-input",
                          name: "reason",
                          "data-vv-as": _vm.$t("Orders.reasonDescription"),
                          error: _vm.veeErrors.has("reason"),
                        },
                        model: {
                          value: _vm.reasonDescription,
                          callback: function ($$v) {
                            _vm.reasonDescription = $$v
                          },
                          expression: "reasonDescription",
                        },
                      }),
                      _c("showValidateError", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.veeErrors.has("reason"),
                            expression: "veeErrors.has('reason')",
                          },
                        ],
                        attrs: { errorName: _vm.veeErrors.first("reason") },
                      }),
                      _c(
                        "Button",
                        {
                          staticClass: "m-top-15 m-left-0",
                          attrs: {
                            primary: "",
                            size: "medium",
                            type: "submit",
                            id: "transfer-description-reason-submit",
                            disabled:
                              _vm.selectedItems.length === 0 ||
                              _vm.isMakingPassive,
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Orders.makePassive"))),
                          ]),
                          _vm.isMakingPassive
                            ? _c("Loading", { attrs: { theme: "disable" } })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.showSelectedTransferList
            ? _c(
                "Button",
                {
                  staticClass: "m-left-10",
                  attrs: {
                    primary: "",
                    id: "btn-turn-to-transfer",
                    size: "small",
                    form: "form-approve-transfer",
                    iconName: "icon-btn-success",
                    disabled:
                      _vm.isFetchingList ||
                      !_vm.isFormValid ||
                      (_vm.selectedItems.length === 0 &&
                        !_vm.showSelectedTransferList) ||
                      _vm.isActionSavedAction,
                    isLoading: _vm.isActionSavedAction,
                  },
                  on: { click: _vm.createRequests },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("RequestedTransfer.createTransferRequest"))
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "content-center" },
        [
          !_vm.hasTabPermission
            ? _c("NoPermission")
            : [
                _vm.isFetchingList || _vm.isPageLoading
                  ? _c("TableLoading")
                  : _vm._e(),
                _vm.isEmptyTransferList &&
                !_vm.isFetchingList &&
                !_vm.isPageLoading
                  ? _c("EmptyState", {
                      attrs: {
                        title: _vm.$t(
                          "RequestedTransfer.emptyState_NotFound_Title"
                        ),
                        description: _vm.$t(
                          "RequestedTransfer.emptyState_NotFound_Description"
                        ),
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "table" },
                  [
                    _c("TableView", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.isEmptyTransferList &&
                            !_vm.isFetchingList &&
                            !_vm.isPageLoading &&
                            !_vm.showSelectedTransferList,
                          expression:
                            "!isEmptyTransferList && !isFetchingList && !isPageLoading && !showSelectedTransferList",
                        },
                      ],
                      attrs: {
                        fields: _vm.fields,
                        data: _vm.items,
                        page: _vm.Page,
                        readOnly: true,
                        actions: [""],
                        componentName: "TransferRequestsTable",
                      },
                      on: {
                        delegateOnChangePage: _vm.changePage,
                        delegateOnChangePageSize: _vm.changePageSize,
                      },
                    }),
                    _c("TableView", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showSelectedTransferList,
                          expression: "showSelectedTransferList",
                        },
                      ],
                      attrs: {
                        fields: _vm.fields,
                        data: _vm.SelectedTransfers,
                        readOnly: true,
                        componentName: "SelectedTransferRequestsTable",
                      },
                    }),
                    _c("portal", { attrs: { to: "headerCheckbox" } }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showSelectedTransferList,
                              expression: "!showSelectedTransferList",
                            },
                          ],
                        },
                        [
                          _c("CustomCheckbox", {
                            attrs: { label: "", checked: _vm.isCheckedAll },
                            on: { change: _vm.toggleAll },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("portal", {
                      attrs: { to: "checkbox" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c(
                              "div",
                              {},
                              [
                                !_vm.showSelectedTransferList
                                  ? _c("CustomCheckbox", {
                                      attrs: {
                                        label: "",
                                        checked:
                                          _vm.selectedItems.some(
                                            (item) => item.id === row.id
                                          ) || _vm.showSelectedTransferList,
                                      },
                                      on: {
                                        change: (isChecked) =>
                                          _vm.toggleSelectItem(isChecked, row),
                                      },
                                    })
                                  : _c("Button", {
                                      attrs: {
                                        size: "small",
                                        justIcon: true,
                                        clearVariant: true,
                                        iconName: "icon-global-remove",
                                        iconClass: "icon-global-remove",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeTransferFromSelectedList(
                                            row
                                          )
                                        },
                                      },
                                    }),
                              ],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "requestDate" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c(
                              "div",
                              {},
                              [
                                _c("CustomDatepicker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        date_format: "YYYY-MM-DD",
                                        before: _vm.dateLimit,
                                      },
                                      expression:
                                        "{ required: true, date_format:'YYYY-MM-DD', before: dateLimit }",
                                    },
                                  ],
                                  staticClass: "custom-picker",
                                  class: {
                                    "is-danger": _vm.veeErrors.has(
                                      `requestDate-${row.rowIndex}`
                                    ),
                                  },
                                  attrs: {
                                    id: `date-picker-requested-transfer-${row.rowIndex}`,
                                    name: `requestDate-${row.rowIndex}`,
                                    position: "left",
                                    pickerType: "manuel",
                                    inputIconRight: "icon-arrow-down",
                                    disabledStartDate: _vm.disabledDate,
                                    isCheckingPosition: false,
                                    inputIcon: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.getStockItemInfo(row)
                                    },
                                    input: function ($event) {
                                      return _vm.changeSelectedTransferDate(
                                        { $event, row },
                                        "requestDate"
                                      )
                                    },
                                  },
                                  model: {
                                    value: row.requestDate,
                                    callback: function ($$v) {
                                      _vm.$set(row, "requestDate", $$v)
                                    },
                                    expression: "row.requestDate",
                                  },
                                }),
                              ],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "unitName" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c("div", {}, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.findUnit(row.unitId)
                                      ? _vm.findUnit(row.unitId).name
                                      : ""
                                  )
                                ),
                              ]),
                            ])
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "quantity" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c("div", { staticClass: "quantity" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    row.sourceType === 2 ? 0 : row.quantity
                                  )
                                ),
                              ]),
                            ])
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "transferredQuantity" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c(
                              "div",
                              { staticClass: "quantity" },
                              [
                                _c("custom-number-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        greater_than: -1,
                                        max: _vm.$getConst(
                                          "MAX_DIGITS_FOR_QUANTITY"
                                        ),
                                        multiplyTwoField: row.unitPrice,
                                      },
                                      expression:
                                        "{required: true, greater_than:-1, max: $getConst('MAX_DIGITS_FOR_QUANTITY'), multiplyTwoField: row.unitPrice}",
                                    },
                                  ],
                                  staticClass: "number-input",
                                  class: {
                                    "is-danger": _vm.veeErrors.has(
                                      `quantity${row.id}`
                                    ),
                                  },
                                  attrs: {
                                    name: `quantity${row.id}`,
                                    id: `input-transfer-request-quantity-${row.rowIndex}`,
                                    disabled:
                                      _vm.Tenant
                                        .approvalRequestTransferPermission,
                                    extraDataEmit: row,
                                    "data-vv-as": _vm.$t(
                                      "RequestedTransfer.tableFieldQuantity"
                                    ),
                                  },
                                  on: {
                                    blur: _vm.changeSelectedTransferQuantity,
                                  },
                                  model: {
                                    value: row.transferedQuantity,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        row,
                                        "transferedQuantity",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "row.transferedQuantity",
                                  },
                                }),
                              ],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "diffQuantity" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c("div", { staticClass: "quantity" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(row.transferedQuantity - row.quantity)
                                ),
                              ]),
                            ])
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "baseUnitQuantity" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c("div", { staticClass: "quantity" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (row.baseQuantity / row.quantity) *
                                      row.transferedQuantity
                                  )
                                ),
                              ]),
                            ])
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "baseUnit" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c("div", {}, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.findUnit(row.baseUnitId)
                                      ? _vm.findUnit(row.baseUnitId).name
                                      : ""
                                  )
                                ),
                              ]),
                            ])
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "total" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c("div", { staticClass: "quantity" }, [
                              _c("div", { staticClass: "quantity" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      row.unitPrice * row.transferedQuantity
                                    )
                                  )
                                ),
                              ]),
                            ])
                          },
                        },
                      ]),
                    }),
                    _c("portal", {
                      attrs: { to: "description" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (row) {
                            return _c(
                              "div",
                              {},
                              [
                                row.description
                                  ? _c(
                                      "Button",
                                      {
                                        staticClass:
                                          "show-MiniPopup relative width-max-content btn-info",
                                        attrs: {
                                          id: "transfer-approval-header-info-button",
                                          iconName: "icon-global-info",
                                          justIcon: true,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "MiniPopup-right-primary m-top-15 c-dark",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(row.description)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
          _c("router-view", { on: { getList: _vm.getFilteredRequestOrders } }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }